import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import cn from "clsx";
import { InputField } from "./inputField";
import { Label } from "../label/label";

export type InputProps = {
  asChild?: boolean;
  iconName?: "search" | "calendar";
  errorMessage?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ errorMessage, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "input";

    return (
      <span className={cn("in-input")}>
        <InputField ref={ref} errorMessage={errorMessage} {...props} />
        {errorMessage && (
          <div className="in-input__error-message">{errorMessage}</div>
        )}
      </span>
    );
  }
);
Input.displayName = "Input";

export { Input };
